'use client';

import { createContext, useContext } from 'react';

import type { PortfolioArrival } from '@/app/(auth)/sign-up/_utils/portfolio-arrival';

export interface PortfolioArrivalNames {
  firstName: string;
  lastName: string;
}

export interface PortfolioArrivalContextValue {
  arrival: PortfolioArrival;
  /**
   * The name on the portfolio, only once BOTH halves are known and would pass the form's own
   * validation. Null while the lookup is in flight, when it failed, and for a name-only portfolio,
   * and in every one of those cases the form keeps asking, as it always has.
   */
  names: PortfolioArrivalNames | null;
}

/**
 * Set inside the portfolio arrival layout only. Null everywhere else, which is what keeps ordinary
 * sign-up traffic byte-for-byte unchanged: the forms branch on this and on nothing else.
 */
export const PortfolioArrivalContext = createContext<PortfolioArrivalContextValue | null>(null);

export function usePortfolioArrival(): PortfolioArrivalContextValue | null {
  return useContext(PortfolioArrivalContext);
}
